import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { PaymentTypesRedux } from '../Redux/PaymentTypesRedux'

const paymentTypesCrudObservable = createCRUDObservable({
  mainRedux: PaymentTypesRedux,
  reduxPath: 'payment_types',
  dataHandlers: {
    get: response => response.data.data,
  },
})

export const paymentTypesObservers = Object.assign({}, paymentTypesCrudObservable.observers, {})

export const paymentTypesEpic = combineEpics(
  paymentTypesCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/PaymentTypesObservable.js